// Central content + brand placeholders. Swap with real brand assets anytime.

export const BRAND = {
  name: "Sahi Claim",
  phone: "+91-9450827416",
  phoneHref: "tel:+919450827416",
  whatsapp: "https://wa.link/ypn0d9",
  email: "info@sahiclaim.com",
  address: "D-4, 1st Floor, Near SDM Office, Swaroop Nagar, New Delhi, 110042",
  hours: "Monday – Saturday | 10:00 AM – 6:00 PM",
};

export const NAV_LINKS = [
  { label: "Claims", href: "#claims" },
  { label: "Process", href: "#process" },
  { label: "Why Us", href: "#why" },
  { label: "Stories", href: "#testimonials" },
  { label: "FAQ", href: "#faq" },
];

export const STATS = [
  { end: 50, prefix: "₹", suffix: " Cr+", label: "Claims assisted" },
  { end: 98, suffix: "%", label: "Resolution success rate" },
  { end: 500, suffix: "+", label: "Policyholders assisted" },
  { value: "PAN India", label: "Claim assistance" },
];

export const FEES = [
  { title: "Free Initial Claim Review", copy: "Share your case and get an honest first assessment — completely free, no obligation." },
  { title: "₹999 Expert Assessment", copy: "Pay only if you choose to proceed and start your claim recovery journey." },
  { title: "20% Success Fee + GST", copy: "Charged only after successful claim recovery, wherever applicable." },
];

export const PARTNERS = [
  "IRDAI Aligned", "Ombudsman", "Legal Panel", "Actuarial Desk", "Forensic Audit",
];

export const CLAIM_TYPES = [
  {
    key: "health",
    title: "Health & Medical",
    copy: "Cashless denials, deductions and post-hospitalisation disputes resolved.",
    image: "https://static.prod-images.emergentagent.com/jobs/09933f45-7de3-4cc6-b08c-72e7b744e64a/images/019aecfa253b8448a67cfb6b34e441cf5348dde16799876672dc60359d732728.jpeg",
    span: "lg:col-span-7",
  },
  {
    key: "life",
    title: "Life",
    copy: "Death & maturity claim rejections contested with documented rigor.",
    image: "https://static.prod-images.emergentagent.com/jobs/09933f45-7de3-4cc6-b08c-72e7b744e64a/images/7f16e394875e34e481632f8ed1e72871dd5e8e027db9b1c8097cbf38af3fc2c7.jpeg",
    span: "lg:col-span-5",
  },
  {
    key: "motor",
    title: "Motor",
    copy: "Accident, theft and total-loss settlements negotiated to full value.",
    image: "https://static.prod-images.emergentagent.com/jobs/09933f45-7de3-4cc6-b08c-72e7b744e64a/images/290d1c26064eebdbd8cd7a0438c366710c979598372505e51ebd0a3105671b5f.jpeg",
    span: "lg:col-span-5",
  },
  {
    key: "property",
    title: "Property & Fire",
    copy: "Surveyor under-assessment and business interruption claims restored.",
    image: "https://static.prod-images.emergentagent.com/jobs/09933f45-7de3-4cc6-b08c-72e7b744e64a/images/a38acb36e18864b2897bde8e02fc55dc4922a1ce3951543ceade232c29fbfc19.jpeg",
    span: "lg:col-span-7",
  },
  {
    key: "travel",
    title: "Travel",
    copy: "Trip cancellation, medical evacuation and baggage claims expedited.",
    image: "https://static.prod-images.emergentagent.com/jobs/09933f45-7de3-4cc6-b08c-72e7b744e64a/images/04ce70469efcaf55bae0c3fb75ca35193f0484a330d867e168f91e41f253b4b3.jpeg",
    span: "lg:col-span-6",
  },
  {
    key: "marine",
    title: "Marine & Cargo",
    copy: "Transit damage, shortage and general average claims documented.",
    image: "https://static.prod-images.emergentagent.com/jobs/09933f45-7de3-4cc6-b08c-72e7b744e64a/images/e026c766a7bae2320c6654755bd58b74d9318e466b5faa4144df355e08a32b3a.jpeg",
    span: "lg:col-span-6",
  },
];

export const PROCESS = [
  {
    no: "01",
    title: "Contact Us",
    copy: "Reach out through our website, WhatsApp, or phone and briefly tell us about your insurance claim.",
    image: "https://static.prod-images.emergentagent.com/jobs/09933f45-7de3-4cc6-b08c-72e7b744e64a/images/dfbb5a95256b6e172e4e006661a8f3e86796d776dfa96ab4c7516ae427b87ac2.jpeg",
  },
  {
    no: "02",
    title: "Share Your Documents",
    copy: "Share your insurance policy, claim documents, rejection letter and supporting records for our expert review.",
    image: "https://static.prod-images.emergentagent.com/jobs/09933f45-7de3-4cc6-b08c-72e7b744e64a/images/def13174d533337fae6c1c4558b0f6125dc623f1b0db8a91029bc70131b9e518.jpeg",
  },
  {
    no: "03",
    title: "Case Acceptance",
    copy: "Our experts carefully review your case. If it is accepted and you choose to proceed, we begin assisting you with the claim recovery process.",
    image: "https://static.prod-images.emergentagent.com/jobs/09933f45-7de3-4cc6-b08c-72e7b744e64a/images/76dd11fd44ed81b43218f6a28c09edf263ed183d8e14241998602b50742bb1ce.jpeg",
  },
  {
    no: "04",
    title: "Registration",
    copy: "A one-time ₹999 Expert Assessment Fee applies only after your case is accepted and you decide to proceed with our professional assistance.",
    image: "https://static.prod-images.emergentagent.com/jobs/09933f45-7de3-4cc6-b08c-72e7b744e64a/images/2830b1011243f37d884a832c57351846393fad7ba255b887f760bfa2ffbf2413.jpeg",
  },
  {
    no: "05",
    title: "Claim Resolution",
    copy: "We represent and support your claim throughout recovery. A 20% Success Fee + GST is payable only after successful recovery, wherever applicable and as agreed.",
    image: "https://static.prod-images.emergentagent.com/jobs/09933f45-7de3-4cc6-b08c-72e7b744e64a/images/b6c66190becbd9ad77bf123b5af7eb94bfa96e96da24c438a0db0e8cb48ff8d7.jpeg",
  },
];

export const WHY = [
  { title: "Fully independent", copy: "We work for you, never the insurer. No commissions, no conflicts, no hidden agenda." },
  { title: "Transparent pricing", copy: "A free initial review, a flat ₹999 assessment if you proceed, and a success fee only on recovery." },
  { title: "Legal-tier expertise", copy: "Ex-insurance counsel, surveyors and actuaries on a single dedicated case desk." },
  { title: "Transparent tracking", copy: "A named advisor and real-time status on every stage of your claim." },
];

export const TESTIMONIALS = [
  {
    quote: "My health claim was rejected twice. Sahi Claim rebuilt the file and helped recover ₹8.4 lakh in six weeks. I never had to argue with the insurer myself.",
    name: "Priya S.",
    role: "Health Claim • Delhi NCR",
    image: "https://static.prod-images.emergentagent.com/jobs/09933f45-7de3-4cc6-b08c-72e7b744e64a/images/cca930178c54917bab2d58dba279eeb14df8a13573181f08e190b73fffff1397.jpeg",
  },
  {
    quote: "The surveyor had under-valued our factory fire loss by nearly half. Their documentation forced a full, fair settlement. A genuinely sharp, professional team.",
    name: "Rajesh M.",
    role: "Property & Fire Claim • Business Owner",
    image: "https://static.prod-images.emergentagent.com/jobs/09933f45-7de3-4cc6-b08c-72e7b744e64a/images/20c7533206c7ed00477294c2521bd20b3586428905e3bf4e2669942754e9df8c.jpeg",
  },
];

export const TESTIMONIALS_FALLBACK = "Verified client stories will be added as they become available.";

export const FAQS = [
  { q: "What does Sahi Claim actually do?", a: "We are an independent claim advisory. We evaluate, document, negotiate and escalate insurance claims on your behalf — so you don't have to fight the insurer alone." },
  { q: "How much do you charge?", a: "The initial claim review is free. If you choose to proceed with our professional assistance, a flat ₹999 Case Assessment & Strategy Fee applies. Thereafter we charge a 20% Success Fee + GST, payable only after successful claim recovery, wherever applicable." },
  { q: "My claim was already rejected. Can you still help?", a: "Yes. A large share of our work is overturning rejected or under-paid claims through the insurer's grievance process, the Insurance Ombudsman, or litigation." },
  { q: "Which types of claims do you handle?", a: "Health, Life, Motor, Property & Fire, Travel and Marine/Cargo claims — for both individuals and businesses." },
  { q: "How long does resolution take?", a: "Most disputes resolve within 4–12 weeks. Complex or litigated matters take longer, and you get a named advisor tracking every stage." },
  { q: "What if my claim is not recovered?", a: "No success fee is charged if we are unable to recover your claim. Only the one-time registration fee is applicable." },
];

export const CLAIM_OPTIONS = ["Health & Medical", "Life", "Motor", "Property & Fire", "Travel", "Marine & Cargo", "Other"];
